import { MakeVaperScreenContent } from "./MakeVaperScreenContentTypes"
import {
    MakeVaperScreenType, MakeVaperSpudPosition, MakeVaperSpudSize, MakeVaperTitleTextPosition, MakeVaperWhiteBoxPosition
} from "./MakeVaperScreenValueTypes"

export enum MakeVaperPart {
    SMART = "smart",
    COOL = "cool",
    POPULAR = "popular",
    EXCITING = "exciting",
    ATHLETIC = "athletic"
}

export interface MakeVaperActivityScreens {
    type: MakeVaperScreenType
    screenContent: Array<MakeVaperScreenContent>
    titleImage?: boolean
    spudTitle?: boolean
    whiteBox?: MakeVaperWhiteBoxPosition
    screenAudio?: string
    titleText?: {
        text: string
        position: MakeVaperTitleTextPosition
    }
    centerContent?: boolean
    enableOnAudioStop?: boolean
    hideSpud?: boolean,
    spudPosition?: MakeVaperSpudPosition
    showFullSpud?: MakeVaperChoices
    spudSize?: MakeVaperSpudSize
    compareColumns?: boolean
    compareSpudSize?: MakeVaperSpudSize
}

export interface MakeVaperChoices {
    athletic?: boolean,
    cool?: boolean,
    exciting?: boolean,
    popular?: boolean,
    smart?: boolean
}
